import { useDashboardLogout } from 'src/components/dashboard/use-dashboard-logout';
import { useHouseholdSwitcher } from 'src/components/household-switcher/use-household-switcher';

import type { ClientPortalAccountMenuState } from './types';

export function useClientPortalAccountMenu(): ClientPortalAccountMenuState {
  const { activeHouseholdId, memberHouseholds, onSelect, switching } = useHouseholdSwitcher();
  const signOut = useDashboardLogout();
  const activeHousehold = memberHouseholds.find((household) => household.id === activeHouseholdId);

  return {
    households: memberHouseholds,
    activeHouseholdId: activeHousehold?.id ?? memberHouseholds[0]?.id ?? null,
    canSwitchHousehold: memberHouseholds.length > 1,
    switching,
    selectHousehold: onSelect,
    signOut,
  };
}
